import React from 'react';
import { useExperiments } from '@wix/wix-experiments-react';
import { GlobalDesignActionLobbyItem } from '../types';
import { processStyleMetadataForLobby } from '../common/lobby/processStyleMetadataForLobby';
import { LobbyItemLayout } from '../common/lobby/LobbyItemLayout';
import BoxShadowPreview from '../controls/GroupPreview/BoxShadowPreview/BoxShadowPreview';
import { useGroupsPreviewPS } from '../common/lobby/useGroupsPreviewPS';
import { GD_WDS_EXPERIMENT } from '../experiments';

const SHADOW_PROPERTY_CONFIG = [
  { resultKey: 'boxShadow', mixedKey: 'isMixed', atomicKeys: 'boxShadow' },
] as const;

const ShadowLobbyItem: GlobalDesignActionLobbyItem = (props) => {
  const { experiments } = useExperiments({ readOnly: true });
  const isWDS = experiments.enabled(GD_WDS_EXPERIMENT);

  // Always call hook (React rules)
  const renderGroupPreviewPS = useGroupsPreviewPS(
    props.actionName,
    props.group,
  );

  const processedStyleMetadata = processStyleMetadataForLobby(
    props.group.engine,
    SHADOW_PROPERTY_CONFIG,
  );
  const value = processedStyleMetadata.boxShadow[0] || '';
  const emptyPreviewLabel =
    props.group.displayName.group || props.group.displayName.component;

  if (!isWDS) {
    return (
      renderGroupPreviewPS({
        value,
        isMixed: processedStyleMetadata.isMixed,
        emptyPreviewLabel,
        onClick: props.onSelect,
      }) ?? null
    );
  }

  return (
    <LobbyItemLayout
      actionName={props.actionName}
      group={props.group}
      onSelect={props.onSelect}
    >
      <BoxShadowPreview
        value={value}
        isMixed={processedStyleMetadata.isMixed}
        emptyPreviewLabel={emptyPreviewLabel}
      />
    </LobbyItemLayout>
  );
};

export default ShadowLobbyItem;
